/** @jsxImportSource @emotion/react */

import React from 'react'

import { mono } from '@components/systems/backoffice/backoffice.tokens'

interface PropsType {
	name: string
	className?: string
	style?: React.CSSProperties
	strokeColor?: string
	strokeWidth?: string
}

/** MDI 아이콘. 기본색은 dim — 색으로 뜻을 만들지 않는다 */
export const Icon = (props: PropsType) => {
	return (
		<span
			className={`mdi mdi-${props.name} ${props.className ?? ''}`}
			css={[{ color: mono.dim, fontSize: 20, lineHeight: 1 }, { ...props.style }]}
		/>
	)
}
